import * as React from "react"
import { cva } from "class-variance-authority";
import {cn} from "../lib/fns";

const containerVariants = cva(
  `h-auton w-full flex items-center justify-between
  bg-card border border-neutral-9
  hover:border-primary hover:shadow-md
  focus-within:border-primary focus-within:shadow-md transition`,
  {
    variants: {
      size: {
        sm: 'h-8 px-2 py-1 has-[>svg]:px-2.5',
        default: 'h-10 px-3 py-2 has-[>svg]:px-3',
        lg: 'h-12 px-2 py-1 rounded-md has-[>svg]:px-4',
      },
      error: {
        true:
          'border-red-500',
      },
      disabled: {
        true:
          'border-neutral-200 bg-neutral-100 hover:border-neutral-200 hover:shadow-none ',
      },
    },
    defaultVariants: {
      error: false,
    },
  },
)

const inputVariants = cva(
  `w-full rounded-lg text-neutral-900 placeholder-neutral-400`,
  {
    variants: {
      size: {
        sm: 'text-sm',
        default: 'h-10 px-3 py-2 has-[>svg]:px-3',
        lg: 'text-md',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
)

export interface InputProps extends Omit<React.ComponentProps<"input">, "size"> {
  size?: "default" | "sm" | "lg";
  error?: boolean;
  innerClassName?: string | undefined;
  icon?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({
     className, innerClassName, type, disabled, icon,
     size, error, ...props
   }, ref) => {
    return (
      <div className={cn(containerVariants({ size, error, disabled, className }))}>
        <input
          ref={ref}
          type={type}
          data-slot="input"
          className={cn(inputVariants({ size, className: innerClassName }))}
          disabled={disabled}
          {...props}
        />
        {icon}
      </div>
    )
  },
)
Input.displayName = "Input"

export { Input }
